import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const NDR: React.FC = () => {
  const sections = [
    {
      title: 'Network Detection and Response (NDR)',
      content: 'Our NDR solutions provide comprehensive network visibility and threat detection capabilities, monitoring network traffic and communications to identify sophisticated attacks, lateral movement, and data exfiltration attempts.',
      benefits: [
        'Real-time network traffic analysis',
        'Advanced threat detection and behavioral analytics',
        'Lateral movement and insider threat detection',
        'Network forensics and investigation capabilities',
        'Integration with SIEM and security orchestration platforms'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Network Detection & Response"
      subtitle="Advanced NDR solutions for comprehensive network monitoring, threat detection, and security analytics."
      sections={sections}
    />
  );
};

export default NDR;

